import { cn } from '../lib/utils.js';

/** @param {import('react').ComponentProps<'table'> & { containerClassName?: string }} props */
export function Table({ className, containerClassName, ...props }) {
  return (
    <div data-slot="table-container" className={cn('relative w-full overflow-auto', containerClassName)}>
      <table data-slot="table" className={cn('w-full caption-bottom text-sm', className)} {...props} />
    </div>
  );
}

/** @param {import('react').ComponentProps<'thead'>} props */
export function TableHeader({ className, ...props }) {
  return <thead data-slot="table-header" className={cn('sticky top-0 z-10 bg-muted [&_tr]:border-b', className)} {...props} />;
}

/** @param {import('react').ComponentProps<'tbody'>} props */
export function TableBody({ className, ...props }) {
  return <tbody data-slot="table-body" className={cn('[&_tr:last-child]:border-0', className)} {...props} />;
}

/** @param {import('react').ComponentProps<'tr'>} props */
export function TableRow({ className, ...props }) {
  return (
    <tr
      data-slot="table-row"
      className={cn('h-(--row-height) border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-accent', className)}
      {...props}
    />
  );
}

/** @param {import('react').ComponentProps<'th'>} props */
export function TableHead({ className, ...props }) {
  return (
    <th
      data-slot="table-head"
      className={cn(
        'h-(--row-height) whitespace-nowrap px-3 text-left align-middle text-xs font-semibold uppercase tracking-wide text-muted-foreground data-[numeric=true]:text-right',
        className,
      )}
      {...props}
    />
  );
}

/** @param {import('react').ComponentProps<'td'>} props */
export function TableCell({ className, ...props }) {
  return (
    <td data-slot="table-cell" className={cn('px-3 py-1.5 align-middle data-[numeric=true]:numeric data-[numeric=true]:text-right', className)} {...props} />
  );
}

/** @param {import('react').ComponentProps<'caption'>} props */
export function TableCaption({ className, ...props }) {
  return <caption data-slot="table-caption" className={cn('mt-3 text-sm text-muted-foreground', className)} {...props} />;
}
